export const hasSubscription = (elem = document) => {
  return elem.querySelector('og-offer')?.hasAttribute('subscribed')
}

export const getSellingPlan = (elem = document) => {
  const hasSubscribed = elem.querySelector('og-offer')?.hasAttribute('subscribed')

  if (!hasSubscribed) {
    return { plan: false, frequency: false }
  }

  const offerElem = elem.querySelector('og-offer')

  const frequency = offerElem.getAttribute('frequency') || false
  const prodId = offerElem.getAttribute('product')

  const query = `#og-selling-plan-map-${prodId}-${frequency}`
  let span = elem.querySelector(query)
  if (!span) {
    const variantID = elem.querySelector('#og-selling-plan-map-main').dataset.variantId
    const query = `#og-selling-plan-map-${variantID}-${frequency}`
    span = elem.querySelector(query)
  }
  if (span) {
    const plan = span.getAttribute('selling-plan-id')
    return { plan, frequency }
  }

  return { plan: false, frequency: false }
}

window.getSellingPlan = getSellingPlan
